const _ = require('lodash')

function normalizeMenuItems (items) {

  const cloned = _.cloneDeep(items || [])

  const walk = (list) => {

    for (const item of list) {

      if (item.type === 'value') {

        item.valueConfig = {
          kind: 'count',
          spreadSheet: '',
          field: '',
          filters: [],
          filterMatchMode: 'all',
          scopeToLoggedInUser: false,
          ...(item.valueConfig || {})
        }

        if (!item.valueConfig.formula) {

          if (item.valueConfig.kind === 'sum' && item.valueConfig.field) {

            item.valueConfig.formula = `SUM({${item.valueConfig.field}})`
          } else if (item.valueConfig.kind !== 'field') {

            item.valueConfig.formula = 'COUNT({id})'
          }
        }

        if (!Array.isArray(item.valueConfig.filters)) item.valueConfig.filters = []
        if (!Array.isArray(item.children)) item.children = []
      }

      if (item.type === 'code' && typeof item.code !== 'string') item.code = ''

      if (item.type === 'dropdown' && !Array.isArray(item.children)) item.children = []

      if (item.children) walk(item.children)
    }
  }

  walk(cloned)

  return cloned
}

module.exports = normalizeMenuItems
